import { Company } from "./Company";
import { getDictionary } from "../utilities/utilities";
import { Validate } from "./Validate";
import { isEmpty } from "lodash";

const dictionary = getDictionary();

export interface ParcelTemplate {
  id: string;
  creationDate: string;
  creationUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  ownerId: string;
  owner: Company;
  name: string;
  parcelTypeCode: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  volume?: number;
  pub?: boolean;
}

export interface CreateParcelTemplate {
  id?: string;
  ownerId?: string;
  name: string;
  parcelTypeCode: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  volume?: number;
  pub?: boolean;
}

export interface UpdateParcelTemplate {
  id: string;
  ownerId?: string;
  name: string;
  parcelTypeCode: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  volume?: number;
  pub?: boolean;
}

export const convertParcelTemplateToCreate = (
  parcelTemplate: ParcelTemplate
): CreateParcelTemplate => {
  return {
    ownerId: parcelTemplate.ownerId,
    name: parcelTemplate.name,
    parcelTypeCode: parcelTemplate.parcelTypeCode,
    height: parcelTemplate.height,
    length: parcelTemplate.length,
    width: parcelTemplate.width,
    weight: parcelTemplate.weight,
    volume: parcelTemplate.volume,
    pub: parcelTemplate.pub,
  };
};

export const convertParcelTemplateToUpdate = (
  parcelTemplate: ParcelTemplate
): UpdateParcelTemplate => {
  return {
    id: parcelTemplate.id,
    ownerId: parcelTemplate.ownerId,
    name: parcelTemplate.name,
    parcelTypeCode: parcelTemplate.parcelTypeCode,
    height: parcelTemplate.height,
    length: parcelTemplate.length,
    width: parcelTemplate.width,
    weight: parcelTemplate.weight,
    volume: parcelTemplate.volume,
    pub: parcelTemplate.pub,
  };
};

export const validate = (parcelTemplate: ParcelTemplate): Validate => {
  const validate: Validate = { isValid: true, errors: {} };

  if (!parcelTemplate.parcelTypeCode) {
    validate.errors.parcelTypeCode = dictionary.messages.mandatory_field;
  }
  if (!parcelTemplate.name) {
    validate.errors.name = dictionary.messages.mandatory_field;
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }
  return validate;
};

export const normalize = (parcelTemplate: ParcelTemplate): ParcelTemplate => {
  const { width, height, length } = parcelTemplate;
  delete parcelTemplate.volume;
  if (width && height && length) {
    parcelTemplate.volume = (height * length * width) / 1000000;
  }
  return parcelTemplate;
};
